import React from 'react';
import { withRouter } from 'react-router-dom';
import {inject, observer } from 'mobx-react'
import { observe } from 'mobx'
import UserLoggedInNavbar from 'components/UserLoggedInNavbar';
import UserNonLoggedInNavbar from 'components/UserNonLoggedInNavbar';

@inject('user')
@observer
class Navbar extends React.Component {

  state = { user: null };

  componentWillMount = () => {
    this.setState({user: this.props.user.userLoggedIn()});
    this.ubsubscribe = observe(this.props.user, newState => this.setState({user: newState.object.userLoggedIn()}))
  };

  componentWillUnmount = () => {
    this.ubsubscribe();
  };


  userLoggedIn = () => {
    return !this.state.user;
  };


  render() {
    const {isNavbarStatic} = this.props;
    return this.userLoggedIn() ?  <UserNonLoggedInNavbar isNavbarStatic={isNavbarStatic} /> : <UserLoggedInNavbar isNavbarStatic={isNavbarStatic} />;
  }
}

export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar.jsx